// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimProviderModel {
    static getAttributeTypeMap() {
        return ClaimProviderModel.attributeTypeMap;
    }
}
ClaimProviderModel.discriminator = undefined;
ClaimProviderModel.additionalProperties = false;
ClaimProviderModel.attributeTypeMap = [
    {
        "name": "typeCode",
        "baseName": "typeCode",
        "type": "string"
    },
    {
        "name": "nameTypeCode",
        "baseName": "nameTypeCode",
        "type": "string"
    },
    {
        "name": "locations",
        "baseName": "locations",
        "type": ""
    },
    {
        "name": "typeId",
        "baseName": "typeId",
        "type": "number"
    },
    {
        "name": "nameTypeId",
        "baseName": "nameTypeId",
        "type": "number"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "taxIdNum",
        "baseName": "taxIdNum",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "number"
    },
    {
        "name": "providerNpi",
        "baseName": "providerNpi",
        "type": "string"
    },
    {
        "name": "unDuplicatorNumber",
        "baseName": "unDuplicatorNumber",
        "type": "number"
    },
    {
        "name": "unDuplicatorLocationNumber",
        "baseName": "unDuplicatorLocationNumber",
        "type": "number"
    },
];
//# sourceMappingURL=claimProviderModel.js.map